export const FormButton = ({_key,name,value,input,change}:any) => {
    return(
        <>
            <label htmlFor={`textInput${_key}`} className="form-label">{name}</label>
            <div className="input-group mb-3" id={`textInput${_key}`}>
                <span className="input-group-text">متن</span>
                <input type="text" className="form-control" onChange={change} name={`${input}:value`} id={`textInput${_key}value`} defaultValue={value.value} placeholder="متن" aria-label="متن"/>
                <span className="input-group-text">لینک</span> 
                <input type="text" className="form-control" onChange={change} name={`${input}:key`} id={`textInput${_key}key`} defaultValue={value.key} placeholder="لینک" aria-label="لینک"/>
            </div>
        </>
    )
}

